import styled from '../../../theme'

const InputRadio = styled.input`
  position: absolute;
  opacity: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  cursor: pointer;
`

export default InputRadio
